import { createContext, useContext } from "react";

export const SiteCtx = createContext({
  content: {},
  lang: "it",
  setLang: () => {},
});

export const useSite = () => useContext(SiteCtx);

export const tx = (field, lang) => {
  if (field == null || field === "") return "";
  if (typeof field === "string") return field;
  return field[lang] ?? field.it ?? "";
};
